import { render, staticRenderFns } from "./TheOrdersView.vue?vue&type=template&id=7e252c94&scoped=true&"
import script from "./TheOrdersView.vue?vue&type=script&lang=js&"
export * from "./TheOrdersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e252c94",
  null
  
)

export default component.exports